var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTokenIconSmall = function SvgTokenIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23.3"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0 0 23.3h4.1l7.4-14.9 7.4 14.9H23z"
  })));
};
export default SvgTokenIconSmall;